/* eslint-disable */
import React, { useContext } from 'react';
import { UserContext } from '../../../App';
import { useNavigate } from 'react-router-dom';
import ContactForm from '../../shared/ContactForm/ContactForm';
import { handleFormSubmit } from '../../../utils/contact-informations';
import dataLayerPush from '../../../utils/data-layer';

function GestionContactInformations() {
    const { company, setCompany, handleChange } = useContext(UserContext);
    const navigate = useNavigate();

    const companyName = company.form.pappers?.denomination || company.form.dealname || 'votre entreprise';

    function handleSuccess() {
        dataLayerPush({ event: 'Clickbutton', eventLabel: 'Gestion - Contact Informations' });

        if (!company.form.transaction_id) {
            const { email, firstname, lastname, phone } = company.form.contact;
            const { legal_statuts } = company.form;
            handleFormSubmit(email, firstname, lastname, phone, legal_statuts, company, setCompany, handleChange);
        }

        navigate('/gestion/accounting');
    }

    return (
        <ContactForm
            title={<>C'est parti pour <span className="important">{companyName}</span> !</>}
            backLink="/gestion/search-company"
            onSuccess={handleSuccess}
        />
    );
}

export default GestionContactInformations;
